import React, { Component } from 'react';
import { LoadingSpinner } from '../common/loading-spinner/LoadingSpinner';

import { createBoard, loadTemplates } from '../../services/api/api';
import config from '../../services/config';

import '../../App.css';
import '../../style/Common.css';
import '../../style/Templates.css';

export default class Templates extends Component {
  constructor() {
    super();
    this.state = {
      templates: [],
      loading: true
    };
  }

  async componentDidMount() {
    const templates = await loadTemplates();

    this.setState({ templates, loading: false });
  }

  async createNewBoard(templateId) {
    const newBoardId = await createBoard({ templateId });
    window.location.href = `/board/${newBoardId}`;
  }

  renderTemplateTile = template => {
    return (
      <li
        key={`template-${template.id}`}
        className="project-item"
        onClick={() => this.createNewBoard(template.id)}
      >
        <div className="project-circle-wrapper">
          <div
            className="project-circle"
            style={{
              backgroundImage: `url(${config.mediaUrl}/images/templates/${template.image})`,
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat'
            }}
          ></div>
        </div>
        <div className="project-title">{template.title}</div>
      </li>
    );
  };

  render() {
    return (
      <div>
        <div className="projects-header d-flex">
          <h2>Available Templates</h2>
        </div>
        <div className="pt-2">
          {this.loading && <LoadingSpinner />}
          {!this.loading && (
            <ul className="project-list d-flex flex-wrap">
              {this.state.templates.map(template => this.renderTemplateTile(template))}
            </ul>
          )}
        </div>
      </div>
    );
  }
}
